import React, { useEffect, useMemo, useRef, useState } from "react";
import LoadingPage from "../Loading/loading";
import { Cookies } from "react-cookie";
import { BiSolidUser, BiSolidHome, BiPhoneCall } from "react-icons/bi";
import { BsChevronDown } from "react-icons/bs";
import { FaFan } from "react-icons/fa";
import DatePicker from "react-datepicker";
import { FaRegEdit } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import { FiSearch } from "react-icons/fi";
import { IoMdSend } from "react-icons/io";
import {
  addActionForLead,
  assignMass,
  deleteLeads,
  getAllCompaniesLeads,
  getAllLeads,
  getChannelsAndProjects,
  getLeadsByType,
  getUsersLeads,
  selfAssign,
  updateLead,
} from "../../network/api/leads";
import { getAllUsers } from "../../network/api/freelance";
import { getAllActions } from "../../network/api/actions";

const ViewLeadsPage = (props) => {
  const cookie = new Cookies();
  const [id, setId] = useState(cookie.get("id"));
  const [searchType, setSearchType] = useState("Created By");
  const [leadsSelected, setLeadsSelected] = useState([]);
  const [leads, setLeads] = useState(null);
  const [pageCount, setPageCount] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [showPopup, setShowPopup] = useState(false);
  const [showPopupOne, setShowPopupOne] = useState(false);
  const [showEditPopup, setEditShowPopup] = useState(false);
  const [showActionPopup, setShowActionPopup] = useState(false);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [search, setSearch] = useState("");
  const [comment, setComment] = useState("");
  const [action, setAction] = useState("");
  const [isDateUpdate, setIsDateUpdate] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [visibleCount, setVisibleCount] = useState(30);
  const [actions, setActions] = useState(null);
  const [channelsAndProjects, setChannelsAndProjects] = useState(null);
  const [currentPage, setCurrentPage] = useState(
    Number(cookie.get("leads_page")) || 1,
  );
  const [users, setUsers] = useState(null);
  const [hoveredRow, setHoveredRow] = useState(null);
  const [actionData, setActionData] = useState(null);
  const [date, setDate] = useState(new Date());
  const [searchValue, setSearchValue] = useState("");

  const handleChange = (e) => {
    e.target.setCustomValidity("");
    const { name, value } = e.target;
    setActionData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const containerRef = useRef();

  const actionsGet = async () => {
    const result = await getAllActions();

    setActions(result.data.actions);
  };

  const filteredUsers = useMemo(() => {
    if (!users) return [];

    return users.filter((u) =>
      u.name.toLowerCase().includes(search.toLowerCase()),
    );
  }, [search, users]);

  const visibleUsers = filteredUsers.slice(0, visibleCount);

  const toggleUser = (user) => {
    setSelectedUsers((prev) => {
      const isSelected = prev.find((u) => u._id === user._id);

      // لو المستخدم مختار بالفعل → شيله عادي
      if (isSelected) {
        return prev.filter((u) => u._id !== user._id);
      }

      // لو وصل للحد الأقصى → امنع الإضافة
      if (prev.length >= leadsSelected.length) {
        return prev;
      }

      // غير كده ضيفه
      return [...prev, user];
    });
  };

  const handleScroll = () => {
    const el = containerRef.current;
    if (!el) return;

    const nearBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 50;

    if (nearBottom && visibleCount < filteredUsers.length) {
      setVisibleCount((prev) => prev + 20);
    }
  };

  const usersGet = async () => {
    setLeads(null);

    let result = await getAllUsers();

    setUsers(result.data.response);
  };

  useEffect(() => {
    usersGet();
    actionsGet();
    getChannelsAndProjects().then((result) => {
      setChannelsAndProjects(result.data);
    });
  }, []);

  useEffect(() => {
    setVisibleCount(30);
  }, [search]);

  const handleAssign = () => {
    assignMass({ leads: leadsSelected, brokers: selectedUsers }).then(
      (result) => {
        if (result.data.message === "Leads assigned successfully") {
          handleClose();
          setLeadsSelected([]);
          handlePageClick(1);
          toast.success(result.data.message, {
            position: "top-right",
          });
          LeadsGet();
        } else {
          toast.error(result.data.message, {
            position: "top-right",
          });
        }
      },
    );
  };

  const handleDelete = () => {
    deleteLeads({ leads: leadsSelected }).then((result) => {
      if (result.data.message === "Leads deleted successfully") {
        handleCloseDelete();
        setLeadsSelected([]);
        handlePageClick(1);
        toast.success(result.data.message, {
          position: "top-right",
        });
        LeadsGet();
      } else {
        toast.error(result.data.message, {
          position: "top-right",
        });
      }
    });
  };

  const handleSelfAssign = () => {
    selfAssign({ leads: leadsSelected }).then((result) => {
      if (result.data.message === "Assigned successfully") {
        handleClose();
        setLeadsSelected([]);
        handlePageClick(1);
        toast.success(result.data.message, {
          position: "top-right",
        });
        LeadsGet();
      } else {
        toast.error(result.data.message, {
          position: "top-right",
        });
      }
    });
  };

  const handleAddActionForLead = () => {
    addActionForLead({
      id: actionData._id,
      action: action,
      actionTime: date.toISOString(),
      comment,
    }).then((result) => {
      if (result.data.message === "Action added") {
        toast.success(result.data.message, {
          position: "top-right",
        });
        handleCloseAction();
        LeadsGet();
      } else {
        toast.error(result.data.message, {
          position: "top-right",
        });
      }
    });
  };

  const handleUpdateLead = () => {
    const formData = {
      name: actionData.name,
      info: actionData.info,
      mobile: actionData.mobile,
      project: actionData.project,
      channel: actionData.channel,
      destination: actionData.destination,
      ...(comment && { comment }),
      ...(isDateUpdate && { time: date.toISOString() }),
      ...(action && { action }),
    };

    updateLead({
      id: actionData._id,
      body: formData,
    }).then((result) => {
      if (result.data.message === "Action edited") {
        toast.success(result.data.message, {
          position: "top-right",
        });
        handleCloseEdit();
        LeadsGet();
      } else {
        toast.error(result.data.message, {
          position: "top-right",
        });
      }
    });
  };

  const LeadsGet = async () => {
    setLeads(null);

    let result;

    if (props.description === "All") {
      result = await getAllLeads(currentPage, searchValue, searchType);
    } else if (props.description === "Company") {
      result = await getAllCompaniesLeads(currentPage, searchValue, searchType);
    } else if (props.description === "User") {
      result = await getUsersLeads(currentPage, searchValue, searchType);
    } else {
      result = await getLeadsByType(
        currentPage,
        props.description,
        props.type,
        searchValue,
        searchType,
        props.assign,
        props.isMe,
      );
    }

    setLeads(result.data.leads);
    setPageCount(result.data.pageCount);
    setTotalCount(result.data.totalCount);
  };

  useEffect(() => {
    LeadsGet();
  }, [currentPage]);

  const handlePageClick = (page) => {
    setCurrentPage(page);
    setLeadsSelected([]);
    cookie.set("leads_page", page);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
      setLeadsSelected([]);
      cookie.set("leads_page", currentPage - 1);
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  const handleNext = () => {
    if (currentPage < pageCount) {
      setCurrentPage(currentPage + 1);
      setLeadsSelected([]);
      cookie.set("leads_page", currentPage + 1);
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  const renderPageNumbers = () => {
    let pages = [];

    if (pageCount <= 10) {
      // Show all pages if less than 10
      for (let i = 1; i <= pageCount; i++) {
        pages.push(i);
      }
    } else {
      // Always show 1-10
      if (currentPage <= 10) {
        for (let i = 1; i <= 10; i++) {
          pages.push(i);
        }
        pages.push("...");
        pages.push(pageCount);
      } else {
        // After page 10, show current - 2 to current + 2
        pages.push(1);
        pages.push("...");
        let start = Math.max(currentPage - 2, 2);
        let end = Math.min(currentPage + 2, pageCount - 1);

        for (let i = start; i <= end; i++) {
          pages.push(i);
        }

        if (end < pageCount - 1) {
          pages.push("...");
        }
        pages.push(pageCount);
      }
    }

    return pages.map((page, index) =>
      page === "..." ? (
        <span key={index} className="px-2">
          ...
        </span>
      ) : (
        <button
          key={index}
          onClick={() => handlePageClick(page)}
          className={
            currentPage === page ? "paginationButtonActive" : "paginationButton"
          }
        >
          {page}
        </button>
      ),
    );
  };

  const handleSelect = (id) => {
    if (leadsSelected.includes(id)) {
      setLeadsSelected(leadsSelected.filter((item) => item !== id));
    } else {
      setLeadsSelected([...leadsSelected, id]);
    }
  };
  const handleSelectAll = () => {
    const allIds = leads.map((item) => item._id);

    if (leadsSelected.length === allIds.length) {
      setLeadsSelected([]); // unselect all
    } else {
      setLeadsSelected(allIds); // select all
    }
  };

  const handleClose = () => {
    if (showPopupOne) {
      setLeadsSelected([]);
    }
    setSearch("");
    setShowPopup(false);
    setShowPopupOne(false);
  };

  const handleCloseAction = () => {
    setActionData(null);
    setShowActionPopup(false);
  };

  const handleCloseDelete = () => {
    setShowDeletePopup(false);
  };

  const handleCloseEdit = () => {
    setActionData(null);
    setEditShowPopup(false);
    setIsDateUpdate(false);
    setComment("");
    setAction("");
    setDate("");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handlePageClick(1);
    LeadsGet();
  };

  return (
    <>
      {leads === null ? (
        <LoadingPage />
      ) : (
        <div className="channel-page">
          <div className="page-header" style={{ flexWrap: "wrap" }}>
            <label>Search By:</label>
            <label style={{ padding: "10px" }}>
              <input
                type="radio"
                name="Created By"
                value="Created By"
                style={{ marginRight: "10px" }}
                checked={searchType === "Created By"}
                onChange={(e) => setSearchType(e.target.value)}
              />
              Created By
            </label>
            <label style={{ padding: "10px" }}>
              <input
                type="radio"
                name="Name"
                value="Name"
                style={{ marginRight: "10px" }}
                checked={searchType === "Name"}
                onChange={(e) => setSearchType(e.target.value)}
              />
              Name
            </label>
            <label style={{ padding: "10px" }}>
              <input
                type="radio"
                name="Project"
                value="Project"
                style={{ marginRight: "10px" }}
                checked={searchType === "Project"}
                onChange={(e) => setSearchType(e.target.value)}
              />
              Project
            </label>
            <label style={{ padding: "10px" }}>
              <input
                type="radio"
                name="Destination"
                value="Destination"
                style={{ marginRight: "10px" }}
                checked={searchType === "Destination"}
                onChange={(e) => setSearchType(e.target.value)}
              />
              Destination
            </label>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="search-input-wrapper">
              <FiSearch className="search-icon" />
              <input
                type="text"
                placeholder={`Search by ${searchType}`}
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
                className="search-input"
              />
              <button
                type="submit"
                style={{
                  background: "none",
                  border: "none",
                  color: "#2980b9",
                  fontSize: "20px",
                  display: "flex",
                  marginLeft: "10px",
                }}
              >
                <IoMdSend />
              </button>
            </div>
          </form>
          <div className="page-header">
            <h2>{props.description} Leads</h2>
            <span>{totalCount || 0} Leads</span>
            {leadsSelected.length > 0 && (
              <div>
                {props.description === "Fresh" &&
                  props.assign !== true &&  
                  props.isMe !== true && (
                    <button
                      style={{ marginRight: "10px" }}
                      className="assignbtn"
                      onClick={() => {
                        setShowPopup(true);
                        setSelectedUsers([]);
                      }}
                    >
                      Assign {leadsSelected.length} Leads
                    </button>
                  )}
                <button
                  className="assignbtn"
                  onClick={() => {
                    setShowDeletePopup(true);
                    setSelectedUsers([]);
                  }}
                >
                  Delete {leadsSelected.length} Leads
                </button>
              </div>
            )}
          </div>

          {leads.length > 0 && (
            <label style={{ padding: "10px" }}>
              <input
                id="check"
                type="checkbox"
                style={{ marginRight: "10px" }}
                checked={leadsSelected.length === leads.length}
                onChange={() => {
                  handleSelectAll();
                }}
              />
              Select all in this page
            </label>
          )}

          {/* DESKTOP TABLE */}
          <div className="table-scroll">
            <div className="table-container">
              <table className="modern-table">
                <thead>
                  <tr>
                    {!props.freelancer && <th>Select</th>}
                    <th>Edit</th>
                    <th>Name</th>
                    <th>Phone</th>
                    <th>Info</th>
                    <th>Destination</th>
                    <th>Channel</th>
                    <th>Project</th>
                    <th>Created by</th>
                    <th>Time</th>
                    <th>Broker</th>
                    <th>Comments</th>
                    <th>Action</th>
                    <th>Action time</th>
                  </tr>
                </thead>

                <tbody>
                  {leads?.map((item) => (
                    <tr
                      key={item._id}
                      onMouseEnter={() => setHoveredRow(item._id)}
                      onMouseLeave={() => setHoveredRow(null)}
                    >
                      {!props.freelancer && (
                        <td>
                          <input
                            id="check"
                            type="checkbox"
                            checked={leadsSelected.includes(item?._id)}
                            onChange={() => {
                              handleSelect(item._id);
                            }}
                          />
                        </td>
                      )}
                      <td>
                        <FaRegEdit
                          onClick={() => {
                            setActionData(item);
                            setEditShowPopup(true);
                            setComment(item.comment);
                            setAction(item?.actions?.action?._id);
                            setDate(new Date(item?.actions?.time));
                          }}
                        />
                      </td>
                      <td>{item?.name}</td>
                      <td>{item?.mobile}</td>
                      <td>{item?.info}</td>
                      <td>{item?.destination}</td>
                      <td>{item?.channel}</td>
                      <td>{item?.project}</td>
                      <td>{item?.createdbyname}</td>
                      <td>{item?.createdAt?.slice(0, 10)}</td>
                      <td>
                        {item?.brokername || leadsSelected.length !== 0 ? (
                          item?.brokername
                        ) : hoveredRow === item._id ? (
                          <button
                            className="assignbtn"
                            onClick={() => {
                              setLeadsSelected([...leadsSelected, item._id]);
                              setShowPopup(true);
                              setShowPopupOne(true);
                              setSelectedUsers([]);
                            }}
                          >
                            Assign
                          </button>
                        ) : (
                          ""
                        )}
                      </td>
                      <td>{item?.comment}</td>
                      <td className="hover-cell">
                        {item?.actions?.action?.name ? (
                          <>
                            {item?.actions?.action?.name}
                            <div className="hidden-content">
                              ({item?.actions?.action?.description})
                            </div>
                          </>
                        ) : hoveredRow === item._id ? (
                          <>
                            {item.broker === id && (
                              <button
                                className="assignbtn"
                                onClick={() => {
                                  setActionData(item);
                                  setShowActionPopup(true);
                                }}
                              >
                                Action
                              </button>
                            )}
                          </>
                        ) : (
                          ""
                        )}
                      </td>
                      <td>
                        {!item?.actions?.time
                          ? ""
                          : item?.actions?.time?.split("T")[0] +
                            " " +
                            item?.actions?.time?.split("T")[1].slice(0, 5)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* MOBILE CARDS */}
          <div className="cards-container">
            {leads?.map((item) => (
              <div className="channel-card" key={item._id}>
                <div className="card-title">{item.name}</div>
                <div className="card-date">
                  {new Date(item.createdAt).toLocaleDateString()}
                </div>
              </div>
            ))}
          </div>

          <div
            className="mt-4"
            style={{
              display: "flex",
              justifyContent: "center",
              flexWrap: "wrap",
              padding: "10px",
            }}
          >
            {currentPage !== 1 && (
              <button
                onClick={handlePrevious}
                disabled={currentPage === 1}
                className="paginationButton"
              >
                Previous
              </button>
            )}
            {renderPageNumbers()}
            {currentPage !== pageCount && pageCount > 0 && (
              <button
                onClick={handleNext}
                disabled={currentPage === pageCount}
                className="paginationButton"
              >
                Next
              </button>
            )}
          </div>
        </div>
      )}

      {showPopup && (
        <div className="popup-overlay">
          <div
            className="popup-box popup-animation"
            onClick={(e) => e.stopPropagation()}
          >
            {/* HEADER */}
            <div className="popup-header">
              <h2>Assign Leads</h2>
              <button className="close-btn" onClick={handleClose}>
                ✕
              </button>
            </div>

            {/* INFO */}
            <p>
              Selected Leads: <b>{leadsSelected.length}</b>
            </p>

            {/* SELECTED USERS CHIPS */}
            <div className="chips">
              {selectedUsers.map((u) => (
                <span key={u._id} className="chip">
                  {u.name}
                  <button onClick={() => toggleUser(u)}>×</button>
                </span>
              ))}
            </div>

            {/* SEARCH */}
            <input
              className="search"
              placeholder="Search users..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />

            {/* USERS LIST */}
            <div
              className="users-list"
              ref={containerRef}
              onScroll={handleScroll}
            >
              {visibleUsers.map((user) => {
                const isSelected = selectedUsers.find(
                  (u) => u._id === user._id,
                );

                return (
                  <div
                    key={user._id}
                    className={`user-item ${isSelected ? "active" : ""}`}
                    onClick={() => toggleUser(user)}
                  >
                    <input type="checkbox" checked={!!isSelected} readOnly />
                    <span>{user.name}</span>
                  </div>
                );
              })}
            </div>

            {/* ACTIONS */}
            <div className="popup-actions">
              <button className="cancel-btn" onClick={handleClose}>
                Cancel
              </button>

              {selectedUsers.length > 0 && (
                <button
                  className="confirm-btn"
                  onClick={handleAssign}
                  disabled={!selectedUsers.length}
                >
                  Assign ({selectedUsers.length})
                </button>
              )}

              {!selectedUsers.length && (
                <button className="confirm-btn" onClick={handleSelfAssign}>
                  Self Assign
                </button>
              )}
            </div>
          </div>
        </div>
      )}

      {showActionPopup && (
        <div className="popup-overlay">
          <div
            className="popup-box popup-animation"
            onClick={(e) => e.stopPropagation()}
          >
            {/* HEADER */}
            <div className="popup-header">
              <h2>Add Action</h2>
              <button className="close-btn" onClick={handleCloseAction}>
                ✕
              </button>
            </div>

            <div className="show-lead row gap-3">
              <div className="item-edit d-flex col-5 align-items-center">
                <span>
                  <BiSolidUser />
                </span>
                <p>{actionData?.name}</p>
              </div>
              <div className="item-edit d-flex col-6 align-items-center">
                <span>
                  <BiPhoneCall />
                </span>
                <p>{actionData.mobile}</p>
              </div>
              {actionData.project !== "" && (
                <div className="item-edit d-flex col-5 align-items-center">
                  <span>
                    <BiSolidHome />
                  </span>
                  <p>{actionData.project}</p>
                </div>
              )}
              {actionData.channel !== "" && (
                <div className="item-edit d-flex col-5 align-items-center">
                  <span>
                    <FaFan />
                  </span>
                  <p>{actionData.channel}</p>
                </div>
              )}
            </div>

            <form onSubmit={handleAddActionForLead}>
              <div className="form-group">
                <label htmlFor="action">Action</label>
                <select
                  className="form-select form-control form-select-lg border border-dark"
                  aria-label="Select Action"
                  name="action"
                  value={action}
                  onChange={(e) => {
                    e.target.setCustomValidity("");
                    setAction(e.target.value);
                  }}
                  style={{
                    width: "100%",
                    padding: "10px",
                    border: "1px solid #ddd",
                    borderRadius: "6px",
                    fontSize: "16px",
                    backgroundColor: "#fff",
                    cursor: "pointer",
                  }}
                  required
                  onInvalid={(e) =>
                    e.target.setCustomValidity("Action is required")
                  }
                >
                  <option disabled value="">
                    Select Action
                  </option>
                  {actions.map((item, index) => (
                    <option key={index} value={item._id}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group" style={{ marginTop: "20px" }}>
                <label htmlFor="Stage Date">Stage Date</label>
                <DatePicker
                  wrapperClassName="date-wrapper"
                  className="date-input"
                  selected={date}
                  onChange={(date) => setDate(date)}
                  showTimeSelect
                  dateFormat="Pp"
                />
              </div>

              <div className="form-group">
                <label htmlFor="comment">Comment</label>
                <textarea
                  type="text"
                  id="comment"
                  name="comment"
                  value={comment}
                  onChange={(e) => {
                    e.target.setCustomValidity("");
                    setComment(e.target.value);
                  }}
                  placeholder="Enter Comment"
                  required
                  onInvalid={(e) =>
                    e.target.setCustomValidity("Comment is required")
                  }
                />
              </div>

              {/* ACTIONS */}
              <div className="popup-actions">
                <button className="cancel-btn" onClick={handleCloseAction}>
                  Cancel
                </button>

                <button className="confirm-btn" type="submit">
                  Add Action
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {showEditPopup && (
        <div className="popup-overlay">
          <div
            className="popup-box popup-animation"
            onClick={(e) => e.stopPropagation()}
          >
            {/* HEADER */}
            <div className="popup-header">
              <h2>Edit</h2>
              <button className="close-btn" onClick={handleCloseEdit}>
                ✕
              </button>
            </div>

            <form onSubmit={handleUpdateLead}>
              <div className="choices-container">
                <div className="form-group">
                  <label htmlFor="Name">Name</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={actionData.name}
                    onChange={handleChange}
                    placeholder="Enter Name"
                    required
                    onInvalid={(e) =>
                      e.target.setCustomValidity("Name is required")
                    }
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="info">User Info</label>
                  <input
                    type="text"
                    id="info"
                    name="info"
                    value={actionData.info}
                    onChange={handleChange}
                    placeholder="Enter User Info"
                    required
                    onInvalid={(e) =>
                      e.target.setCustomValidity("User Info is required")
                    }
                  />
                </div>
              </div>

              <div className="choices-container">
                <div className="form-group">
                  <label htmlFor="mobile">User Phone</label>
                  <input
                    type="text"
                    id="mobile"
                    name="mobile"
                    value={actionData.mobile}
                    onChange={handleChange}
                    placeholder="Enter User Phone"
                    required
                    onInvalid={(e) =>
                      e.target.setCustomValidity("User Phone is required")
                    }
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="destination">User Destination</label>
                  <input
                    type="text"
                    id="destination"
                    name="destination"
                    value={actionData.destination}
                    onChange={handleChange}
                    placeholder="Enter User Destination"
                    required
                    onInvalid={(e) =>
                      e.target.setCustomValidity("User Destination is required")
                    }
                  />
                </div>
              </div>

              <div className="choices-container">
                <div className="form-group">
                  <label htmlFor="region">Project</label>
                  <select
                    className="form-select form-control form-select-lg border border-dark"
                    aria-label="Select Project"
                    name="project" // Changed from type2 to be more descriptive
                    value={actionData.project}
                    onChange={(e) => {
                      e.target.setCustomValidity("");
                      setActionData({
                        ...actionData,
                        project: e.target.value,
                      });
                    }}
                    style={{
                      width: "100%",
                      padding: "10px",
                      border: "1px solid #ddd",
                      borderRadius: "6px",
                      fontSize: "16px",
                      backgroundColor: "#fff",
                      cursor: "pointer",
                    }}
                    required
                    onInvalid={(e) =>
                      e.target.setCustomValidity("Project is required")
                    }
                  >
                    <option disabled value="">
                      Select Project
                    </option>
                    {channelsAndProjects.projects?.map((item, index) => (
                      <option key={index} value={item.name}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="channel">Channel</label>
                  <select
                    className="form-select form-control form-select-lg border border-dark"
                    aria-label="Select Channel"
                    name="channel" // Changed from type2 to be more descriptive
                    value={actionData.channel}
                    onChange={(e) => {
                      e.target.setCustomValidity("");
                      setActionData({
                        ...actionData,
                        channel: e.target.value,
                      });
                    }}
                    style={{
                      width: "100%",
                      padding: "10px",
                      border: "1px solid #ddd",
                      borderRadius: "6px",
                      fontSize: "16px",
                      backgroundColor: "#fff",
                      cursor: "pointer",
                    }}
                    required
                    onInvalid={(e) => e.target.setCustomValidity("Channel")}
                  >
                    <option disabled value="">
                      Select Channel
                    </option>
                    {channelsAndProjects.channels?.map((item, index) => (
                      <option key={index} value={item.name}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {actionData.actions && (
                <>
                  <div className="form-group">
                    <label htmlFor="action">Action</label>
                    <select
                      className="form-select form-control form-select-lg border border-dark"
                      aria-label="Select Action"
                      name="action"
                      value={action}
                      onChange={(e) => {
                        e.target.setCustomValidity("");
                        setAction(e.target.value);
                      }}
                      style={{
                        width: "100%",
                        padding: "10px",
                        border: "1px solid #ddd",
                        borderRadius: "6px",
                        fontSize: "16px",
                        backgroundColor: "#fff",
                        cursor: "pointer",
                      }}
                      required
                      onInvalid={(e) =>
                        e.target.setCustomValidity("Action is required")
                      }
                    >
                      <option disabled value="">
                        Select Action
                      </option>
                      {actions.map((item, index) => (
                        <option key={index} value={item._id}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="form-group" style={{ marginTop: "20px" }}>
                    <label htmlFor="Stage Date">Stage Date</label>
                    <DatePicker
                      wrapperClassName="date-wrapper"
                      className="date-input"
                      selected={date}
                      onChange={(date) => {
                        setIsDateUpdate(true);
                        setDate(date);
                      }}
                      showTimeSelect
                      dateFormat="Pp"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="comment">Comment</label>
                    <textarea
                      type="text"
                      id="comment"
                      name="comment"
                      value={comment}
                      onChange={(e) => {
                        e.target.setCustomValidity("");
                        setComment(e.target.value);
                      }}
                      placeholder="Enter Comment"
                      required
                      onInvalid={(e) =>
                        e.target.setCustomValidity("Comment is required")
                      }
                    />
                  </div>
                </>
              )}

              {/* ACTIONS */}
              <div className="popup-actions">
                <button className="cancel-btn" onClick={handleCloseEdit}>
                  Cancel
                </button>

                <button className="confirm-btn" type="submit">
                  Edit
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {showDeletePopup && (
        <div className="popup-overlay">
          <div
            className="popup-box popup-animation"
            onClick={(e) => e.stopPropagation()}
          >
            {/* HEADER */}
            <div className="popup-header">
              <h2>Delete Leads</h2>
              <button className="close-btn" onClick={handleCloseDelete}>
                ✕
              </button>
            </div>

            <div className="show-lead row gap-3">
              <div className="item-edit d-flex col-5 align-items-center">
                <p>You want to delete this leads?</p>
              </div>
            </div>
            <div className="popup-actions">
              <button className="cancel-btn" onClick={handleCloseDelete}>
                No
              </button>

              <button className="confirm-btn" onClick={handleDelete}>
                Yes
              </button>
            </div>
          </div>
        </div>
      )}
      <ToastContainer />
    </>
  );
};

export default ViewLeadsPage;
